export default "__VITE_ASSET__5d203a66__"